import React, { useState } from "react";
import { Sparkles, Check, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

// Assistant's proposal for a sharper description of a stage that has not run yet (auto at gates, or on request).
export function StepSuggestion({ task, s, i, onDone, canRequest }) {
  const [busy, setBusy] = useState("");
  const sug = s.suggestion;
  const call = async (key, fn, ok) => {
    setBusy(key);
    try { await fn(); if (ok) toast.success(ok); onDone?.(); } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); } finally { setBusy(""); }
  };
  if (!sug) {
    if (!canRequest) return null;
    return (
      <button type="button" disabled={!!busy} onClick={() => call("ask", () => api.post(`/tasks/${task.id}/steps/${s.id}/suggest`))}
        className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-[#7C3AED] hover:underline disabled:opacity-60" data-testid={`wf-step-suggest-${i}`}>
        {busy ? <Loader2 size={11} className="animate-spin" /> : <Sparkles size={11} />} Minta usulan asisten untuk tahap ini
      </button>
    );
  }
  return (
    <div className="mt-2 rounded-xl border border-[#E7E0FF] bg-[#FAF8FF] p-3 text-xs" data-testid={`wf-step-suggestion-${i}`}>
      <p className="flex items-center gap-1 font-semibold text-[#7C3AED]"><Sparkles size={12} /> Usulan asisten{sug.by ? ` (${sug.by})` : ""}</p>
      {sug.reason && <p className="mt-1 text-slate-500" data-no-i18n>{sug.reason}</p>}
      <p className="mt-1.5 whitespace-pre-wrap text-slate-700" data-no-i18n data-testid={`wf-step-suggestion-text-${i}`}>{sug.description}</p>
      <div className="mt-2 flex gap-2">
        <button type="button" disabled={!!busy} onClick={() => call("apply", () => api.post(`/tasks/${task.id}/steps/${s.id}/suggest/apply`), "Deskripsi tahap diperbarui")}
          className="inline-flex items-center gap-1 rounded-lg bg-[#7C3AED] px-3 py-1.5 font-bold text-white disabled:opacity-60" data-testid={`wf-step-suggestion-apply-${i}`}>
          {busy === "apply" ? <Loader2 size={11} className="animate-spin" /> : <Check size={11} />} Terapkan
        </button>
        <button type="button" disabled={!!busy} onClick={() => call("dismiss", () => api.delete(`/tasks/${task.id}/steps/${s.id}/suggest`))}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-1.5 font-semibold text-slate-600 disabled:opacity-60" data-testid={`wf-step-suggestion-dismiss-${i}`}>
          <X size={11} /> Abaikan
        </button>
      </div>
    </div>
  );
}
